import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

export default function Value() {
  // Tạo ref cho mỗi thành viên
  // const lettersRef = Array.from({ length: 7 }, () => useRef(null));
  const ref = useRef(null);

  // Detect when the container is in view
  const isInView = useInView(ref, { once: 1 });

  // Kiểm tra xem các thành viên đã xuất hiện trong viewport chưa
  // const letterInView = lettersRef.map((ref) =>
  //   useInView(ref, { threshold: 0.1 })
  // );
  const createAnimationDropDown = (delay) => ({
    hidden: { opacity: 0, y: -50 }, // Start hidden and above the viewport
    visible: {
      opacity: 1,
      y: 0, // Move to its original position
      transition: { duration: 0.6, delay }, // Add delay for each member
    },
  });
  const createAnimationVariant = (delay) => ({
    hidden: { opacity: 0, rotate: -45, x: 50 }, // Bắt đầu với xoay -45 độ và nằm ở phía bên phải
    visible: {
      opacity: 1,
      rotate: 0, // Xoay về vị trí gốc (0 độ)
      x: 0, // Di chuyển về vị trí gốc
      transition: { duration: 0.5, delay }, // Thêm độ trễ cho mỗi phần tử
    },
  });

  return (
    <div className="flex flex-col items-center">
      <div className="relative h-[985px] w-[1440px] bg-white ">
        <div
          className=" h-[433px]  "
          style={{ backgroundImage: "url('/icons/Values/IMG.png')" }}
        ></div>
        <div
          className="absolute  bg-no-repeat h-[574px] w-[1000px] flex items-center justify-start top-[412px] left-[81px]"
          style={{ backgroundImage: "url('/icons/Values/WTM.png')" }}
        >
          <img
            className="relative bottom-20"
            alt="logo"
            src="/icons/Values/TITLE.png"
          ></img>
        </div>

        <div className="absolute top-[359px] left-[610px] text-justify pr-[72px] ">
          <div className="pt-[13px] text-[18px] w-[751px] ">
            <p className=" relative  font-bold text-lg leading-6  text-black ">
              <motion.div
                variants={createAnimationVariant(2)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
              >
                ervice-Minded:{" "}
                <span className="font-normal ">
                  We are dedicated to delivering exceptional and meaningful
                  experiences for our customers, communities, and the teams we
                  support. Our passion for quality service is evident in every
                  interaction and commitment we make.
                </span>
              </motion.div>
              <motion.div

                variants={createAnimationDropDown(0.2)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
                className="font-inter absolute -top-[4px] -left-[21px] text-center   text-[#EB1F27] font-bold text-[31px]"
              >
                S
              </motion.div>
            </p>
            <p className="relative font-bold text-lg leading-6 mt-3 text-black ">
              <motion.div
                variants={createAnimationVariant(2)} // No delay for the first member
                initial="hidden"
                ref={ref}
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
              >
                erformance:
                <span className="font-normal ">
                  We are dedicated to continuous improvement and pushing beyond
                  our comfort zones. At Spiral LLC, we foster a
                  performance-oriented culture where teamwork drives us to
                  achieve new heights and deliver exceptional results.
                </span>
              </motion.div>
              <motion.div

                variants={createAnimationDropDown(0.4)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
                className="font-inter absolute -top-[4px] -left-[21px] text-center   text-[#EB1F27] font-bold text-[31px]"
              >
                P
              </motion.div>
            </p>
            <p className="relative font-bold text-lg leading-6 mt-3 text-black ">
              <motion.div
                variants={createAnimationVariant(2)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
              >
                ntegrity:
                <span className="font-normal ">
                  Honesty and transparency are at the heart of everything we do.
                  We are committed to the best interests of our customers and
                  our company, working openly and collaboratively to pursue
                  truth and trust.
                </span>
              </motion.div>
              <motion.div
                variants={createAnimationDropDown(0.6)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
                className="font-inter absolute -top-[4px] -left-4   text-[#EB1F27] font-bold text-[31px]"
              >
                I
              </motion.div>
            </p>
            <p className="relative font-bold text-lg leading-6 mt-3 text-black ">
              <motion.div
                variants={createAnimationVariant(2)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
              >
                nnovation:
                <span className="font-normal ">
                  At Spiral LLC, we embrace challenges with creativity and
                  determination. We inspire growth and innovation through
                  continuous learning and bold actions, always seeking new ways
                  to solve complex problems.
                </span>
              </motion.div>
              <motion.div
                variants={createAnimationDropDown(0.8)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
                className="font-inter absolute -top-[4px] -left-4  flex text-[#EB1F27] font-bold text-[31px]"
              >
                I
              </motion.div>
            </p>
            <p className="relative font-bold text-lg leading-6 mt-3 text-black ">
              <motion.div
                variants={createAnimationVariant(2)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
              >
                esilience:
                <span className="font-normal ">
                  Adaptability is key in our ever-changing environment. We pride
                  ourselves on our flexibility and embrace every opportunity to
                  learn, ensuring that circumstances never hold us back from
                  success.
                </span>
              </motion.div>
              <motion.div
                variants={createAnimationDropDown(1)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
                className="font-inter absolute -top-[4px] -left-[21px] text-center   text-[#EB1F27] font-bold text-[31px]"
              >
                R
              </motion.div>
            </p>
            <p className="relative font-bold text-lg leading-6 mt-3 text-black ">
              <motion.div
                variants={createAnimationVariant(2)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
              >
                ccountability:
                <span className="font-normal ">
                  We take full responsibility for our actions, decisions, and
                  performance. By proactively addressing challenges, we find the
                  best solutions and uphold our commitment to excellence.
                </span>
              </motion.div>
              <motion.div
                variants={createAnimationDropDown(1.2)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
                className="font-inter absolute -top-[4px] -left-6 text-center   text-[#EB1F27] font-bold text-[31px]"
              >
                A
              </motion.div>
            </p>
            <p className="relative font-bold text-lg leading-6 mt-3 text-black ">
              <motion.div
                variants={createAnimationVariant(2)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
              >
                inkages:
                <span className="font-normal ">
                  Valuing every business relationship, we invest time, energy,
                  and care to nurture and strengthen partnerships. Our focus on
                  mutually beneficial connections is integral to our success and
                  the success of our clients.{" "}
                </span>
              </motion.div>

              <motion.div

                variants={createAnimationDropDown(1.4)} // No delay for the first member
                initial="hidden"
                animate={isInView ? "visible" : "hidden"} // Kiểm tra xem đã vào viewport chưa
                className="font-inter absolute -top-[4px] -left-[21px] text-center   text-[#EB1F27] font-bold text-[31px]"
              >
                L
              </motion.div>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
